// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoCard_container__dmetH","text":"InfoCard_text__2s9_s","normal":"InfoCard_normal__1cKhx","big":"InfoCard_big__Y6ZAA","note":"InfoCard_note__3osV7"};